import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomers } from "../contexts/customerContext";

const PrivateRoute = ({ children }: any) => {
  const { isAuthenticated } = useCustomers();

  if (isAuthenticated === null) return;

  if (!isAuthenticated) {
    return <Navigate to="/otp-login" />;
  }

  return children;
};

export default PrivateRoute;
